namespace $.$$ {

	$mol_style_define( $shm_agent_message_chart, {
		position: 'relative',
		width: '100%',
		minWidth: 0,
		flex: {
			shrink: 0,
		},
		background: {
			color: $mol_theme.card,
		},
		border: {
			radius: $mol_gap.round,
		},
		overflow: 'hidden',
	} )

}
